
export default {
	headline: {
		english: {
			default: <>Make your money work how you want it to with Wells Fargo checking</>,
			startsmart: <>Help them learn smart <br/>money skills with Clear&nbsp;Access&nbsp;Banking</>,
		},
		spanish: {
			default: <>Una cuenta de cheques de Wells Fargo te ofrece las herramientas que necesitas para ayudar a manejar tu dinero fácilmente desde la app.</>,
		}
	},

};
